const getters = {
    getServiceRequestChalans(state) {
        return state.serviceRequestChalansList;
    }
}


export default getters;